<ng-progress [spinner]="false" [color]="'#a7d7c5'"></ng-progress>
<router-outlet></router-outlet>
<app-modal></app-modal>
<app-bottom-modal></app-bottom-modal>